import { onBeforeUnmount, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { myUnread } from '../api/portal';
import { listenForMessages } from './useMessagesLive';

// A slow fallback: updates and email-only sends have no live event.
const POLL_MS = 60000;

/**
 * The Messages badge. `null` until the count is known and after any failure —
 * including the 403 staff get when previewing — so the badge hides rather than
 * showing a stale or zero count. Refetched on every page change (the path: the Library's tab and search live in the query and change per keystroke) and whenever
 * the thread moves, which is what clears it without a reload; a 60s poll
 * behind that catches agency updates, which have no live event here.
 */
export function usePortalUnread() {
  const total = ref(null);
  const route = useRoute();

  let refused = false;
  // Only the newest request may write. On Messages the page-change fetch and
  // the refresh after the thread is read overlap, and the older answer (the
  // pre-read count) can arrive last.
  let latest = 0;

  const refresh = async () => {
    if (refused) return;
    const mine = ++latest;
    try {
      const { total: count } = await myUnread();
      if (mine === latest) total.value = count;
    } catch (e) {
      if (mine !== latest) return;
      total.value = null;
      // Staff previewing are refused every time; stop asking.
      refused = e?.response?.status === 403;
    }
  };

  void refresh();
  watch(() => route.path, refresh);
  const stop = listenForMessages(refresh);
  const timer = setInterval(refresh, POLL_MS);
  onBeforeUnmount(() => {
    stop();
    clearInterval(timer);
  });

  return { total, refresh };
}
